export const FETCH_LOCATION_BASED_REQUEST = "FETCH_LOCATION_BASED_REQUEST";
export const FETCH_LOCATION_BASED_SUCCESS = "FETCH_LOCATION_BASED_SUCCESS";
export const FETCH_LOCATION_BASED_FAILURE = "FETCH_LOCATION_BASED_FAILURE";

export const FETCH_LOCATION_BASED_EMPLOYEES_REQUEST = "FETCH_LOCATION_BASED_EMPLOYEES_REQUEST";
export const FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS = "FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS";
export const FETCH_LOCATION_BASED_EMPLOYEES_FAILURE = "FETCH_LOCATION_BASED_EMPLOYEES_FAILURE";